import { render } from "./TimeoutView.vue?vue&type=template&id=2f24347c&scoped=true"
import script from "./TimeoutView.vue?vue&type=script&lang=js"
export * from "./TimeoutView.vue?vue&type=script&lang=js"

import "./TimeoutView.vue?vue&type=style&index=0&id=2f24347c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f24347c"]])

export default __exports__